function OnsiteSitesView(filterService) {
    return {
        redirect: 'E',
        replace: true,
        scope: {
            visits: "=",
            reports: "=",
            filterReport: "="
        },
		template: require('./sites-view.html'),

        link: function (scope) {
            scope.sortField = 'siteName';
            scope.siteVisits = [];

            function applyFilters(newValue) {
                if (!(newValue instanceof Array)) {
                    return;
                }
                var tempVisits = filterService.transformVisitsBySite([].concat(newValue));
                tempVisits = filterService.sortSites(scope.sortField, tempVisits);
                scope.siteVisits = tempVisits;
            }

            scope.onSortChange = function(){
                applyFilters(scope.visits);
            };

            (function () {
                scope.$watch('visits', applyFilters, true);
            })();
        }
    }
}

angular.module('onsite').directive('onsiteSitesView', ['onsiteUiFilterService', OnsiteSitesView]);
